import React from 'react';
import pt from 'prop-types';

import Icon from 'components/icon';

function SwellColorPickerPreset({ presets, onChange }) {
  const [open, setOpen] = React.useState(true);

  const onToggle = React.useCallback((event) => {
    event.preventDefault();
    setOpen((open) => !open);
  }, []);

  const onPresetClick = React.useCallback(
    (event) => {
      onChange(event.currentTarget.dataset.color);
    },
    [onChange],
  );

  return (
    <details
      className="storefront-editor--color-scheme--picker--preset"
      open={open}
    >
      <summary onClick={onToggle}>
        Currently used{' '}
        <Icon
          fa={open ? 'chevron-up' : 'chevron-down'}
          faSize="1x"
          width={20}
          height={20}
        />
      </summary>

      <ul className="storefront-editor--color-scheme--picker--preset-list">
        {presets.map((color) => (
          <li key={color}>
            <button
              title={color}
              aria-label={color}
              data-color={color}
              style={{ background: color }}
              className="storefront-editor--color-scheme--picker--preset-item"
              onClick={onPresetClick}
              type="button"
            />
          </li>
        ))}
      </ul>
    </details>
  );
}

SwellColorPickerPreset.propTypes = {
  presets: pt.arrayOf(pt.string).isRequired,

  onChange: pt.func.isRequired,
};

export default React.memo(SwellColorPickerPreset);
